import { CALL_SESSION_TYPE } from 'utils/enums';

export const CALL_SESSION_OPTION = {
  [CALL_SESSION_TYPE.ERROR]: {
    color: '#D1131D',
    textColor: '#D1131D'
  },
  [CALL_SESSION_TYPE.WARNING]: {
    color: '#FF9500',
    textColor: '#FF9500'
  },
  [CALL_SESSION_TYPE.NORMAL]: {
    color: '#1564E8',
    textColor: '#878787'
  },
  [CALL_SESSION_TYPE.INFO]: {
    color: '#B2B9C4',
    textColor: '#878787'
  }
};
